import React from 'react';
import { motion } from 'framer-motion';
import { Check, Rocket, Sprout, TrendingUp } from 'lucide-react';
import styles from './GrowthJourney.module.css';

const STAGES = [
    {
        icon: Rocket, when: 'Week 1', title: 'Up and running',
        points: ['We set up your services, staff and prices with you', 'Your first branded bills go out on WhatsApp', 'Khata, memberships and packages move off paper'],
    },
    {
        icon: Sprout, when: 'Month 1', title: 'Chairs stay full',
        points: ['Reminders cut no-shows', 'Prepaid cards start bringing cash in advance', 'A daily summary reaches you on WhatsApp'],
    },
    {
        icon: TrendingUp, when: 'Month 3', title: 'A salon that grows on its own',
        points: ['Lost clients come back through campaigns', 'Packages lock in visits for months ahead', 'Your team sells more, with clear credit and incentives'],
    },
];

export default function GrowthJourney() {
    return (
        <ol className={styles.track}>
            {STAGES.map((s, i) => {
                const Icon = s.icon;
                return (
                    <motion.li
                        key={s.when}
                        className={styles.stage}
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.4 }}
                        transition={{ duration: 0.6, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
                    >
                        <div className={styles.head}>
                            <span className={styles.icon}><Icon size={18} /></span>
                            <span className={styles.when}>{s.when}</span>
                        </div>
                        <h3>{s.title}</h3>
                        <ul>{s.points.map((p) => <li key={p}><Check size={13} strokeWidth={3} /> {p}</li>)}</ul>
                    </motion.li>
                );
            })}
        </ol>
    );
}
